import React from 'react';
import { Star, Quote } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    text: 'Pasé de improvisar todas mis clases a tener todo organizado. Me ahorra horas.',
    name: 'Laura M.',
    city: 'Buenos Aires',
    image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?q=80&w=150&auto=format&fit=crop'
  }, {
    text: 'Mis alumnos participan mucho más. Antes se aburrían, ahora esperan la clase.',
    name: 'Diego F.',
    city: 'Córdoba',
    image: 'https://images.unsplash.com/photo-1599566150163-29194dcaad36?q=80&w=150&auto=format&fit=crop'
  }, {
    text: 'El sistema me dio seguridad total. Ahora sé exactamente qué hacer en cada clase.',
    name: 'Mariana S.',
    city: 'Rosario',
    image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?q=80&w=150&auto=format&fit=crop'
  }, {
    text: 'Doy clases particulares y esto me salvó la vida. La progresión de los temas es perfecta para A1-A2.',
    name: 'Julieta R.',
    city: 'Mendoza',
    image: 'https://images.unsplash.com/photo-1517841905240-472988babdf9?q=80&w=150&auto=format&fit=crop'
  }, {
    text: 'Los juegos y dinámicas son excelentes. Mis alumnos adultos se divierten un montón y aprenden más rápido.',
    name: 'Martín L.',
    city: 'La Plata',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?q=80&w=150&auto=format&fit=crop'
  }, {
    text: 'El bono de cómo conseguir alumnos me ayudó a llenar mis horarios en menos de un mes. Increíble.',
    name: 'Florencia C.',
    city: 'Mar del Plata',
    image: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?q=80&w=150&auto=format&fit=crop'
  }, {
    text: 'Antes pasaba mis fines de semana planificando. Ahora en 15 minutos tengo la clase lista. Vale cada peso.',
    name: 'Tomás V.',
    city: 'Tucumán',
    image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?q=80&w=150&auto=format&fit=crop'
  }, {
    text: 'Las preguntas de conversación destraban hasta al alumno más tímido. Muy buen material, súper recomendable.',
    name: 'Camila B.',
    city: 'Buenos Aires',
    image: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?q=80&w=150&auto=format&fit=crop'
  }];
  return <section className="py-12 md:py-20 italian-cream" data-id="element-263">
      <div className="container mx-auto px-4 max-w-7xl" data-id="element-264">
        <div className="text-center mb-8 md:mb-14" data-id="element-265">
          <p className="text-xs md:text-sm font-bold tracking-widest text-emerald-600 uppercase mb-2" data-id="element-266">
            RESULTADOS REALES
          </p>
          <h2 className="font-display text-3xl md:text-5xl font-bold text-slate-900 mb-3" data-id="element-267">
            Lo que dicen los profesores
          </h2>
          <p className="text-sm md:text-lg text-slate-600" data-id="element-268">
            Profesionales que ya usan el sistema
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 md:gap-5" data-id="element-269">
          {testimonials.map((test, idx) => <div key={idx} className="bg-white p-4 md:p-6 rounded-xl md:rounded-2xl shadow-sm border border-slate-200 flex flex-col h-full hover:shadow-lg transition-shadow relative" data-id="element-270">
              <Quote className="absolute top-3 right-3 w-5 h-5 md:w-6 md:h-6 text-emerald-100" data-id="element-271" />
              <div className="flex gap-0.5 mb-3 text-amber-400" data-id="element-272">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-3.5 h-3.5 md:w-4 md:h-4 fill-current" data-id="element-273" />)}
              </div>
              <p className="text-sm md:text-base text-slate-700 italic mb-4 flex-grow leading-snug" data-id="element-274">
                "{test.text}"
              </p>
              <div className="flex items-center gap-3 mt-auto pt-3 border-t border-slate-100" data-id="element-275">
                <img src={test.image} alt={test.name} className="w-9 h-9 md:w-10 md:h-10 rounded-full object-cover" data-id="element-276" />
                <div data-id="element-277">
                  <p className="font-bold text-slate-900 text-xs md:text-sm" data-id="element-278">
                    {test.name}
                  </p>
                  <p className="text-[10px] md:text-xs text-slate-500" data-id="element-279">
                    {test.city}, Argentina 🇦🇷
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}